import * as React from "react";
import { cn } from "../../lib/utils";

const formatNumber = (value) => {
  if (value === "" || value === null || value === undefined) return "";
  
  // Sayıya çevir
  const num = typeof value === "string" ? parseFloat(value.replace(/\./g, "").replace(",", ".")) : value;
  
  if (isNaN(num)) return "";
  
  // Türk formatında göster (1.234,56) - her zaman 2 ondalık basamak
  return num.toLocaleString("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const parseNumber = (formattedValue) => {
  if (!formattedValue || formattedValue === "") return "";
  
  // Türk formatından sayıya çevir
  const cleaned = formattedValue.replace(/\./g, "").replace(",", ".");
  const num = parseFloat(cleaned);
  
  return isNaN(num) ? "" : num;
};

const CurrencyInput = React.forwardRef(
  ({ className, value, onChange, placeholder = "0", ...props }, ref) => {
    const [displayValue, setDisplayValue] = React.useState("");
    const [isFocused, setIsFocused] = React.useState(false);

    React.useEffect(() => {
      // Only update displayValue from prop when input is NOT focused
      // This prevents formatting interference while user is typing
      if (!isFocused) {
        if (value === 0 || value === "0" || value === "" || value === null || value === undefined) {
          setDisplayValue("");
        } else {
          setDisplayValue(formatNumber(value));
        }
      }
    }, [value, isFocused]);

    const handleChange = (e) => {
      const inputValue = e.target.value;
      
      // Boş değer kontrolü
      if (inputValue === "") {
        setDisplayValue("");
        if (onChange) {
          onChange("");
        }
        return;
      }
      
      // Sadece rakam, nokta ve virgül kabul et
      let cleaned = inputValue.replace(/[^\d.,]/g, "");
      
      // Binlik ayraçları (noktaları) kaldır
      cleaned = cleaned.replace(/\./g, "");
      
      // Birden fazla virgül varsa sadece ilkini al
      const commaParts = cleaned.split(",");
      if (commaParts.length > 2) {
        cleaned = commaParts[0] + "," + commaParts.slice(1).join("");
      }
      
      // Ondalık kısmı 2 basamakla sınırla
      if (cleaned.includes(",")) {
        const parts = cleaned.split(",");
        if (parts[1] && parts[1].length > 2) {
          cleaned = parts[0] + "," + parts[1].substring(0, 2);
        }
      }
      
      setDisplayValue(cleaned);
      
      // Parent'a sayısal değer gönder
      const numericValue = parseNumber(cleaned);
      if (onChange) {
        onChange(numericValue);
      }
    };

    const handleFocus = () => {
      setIsFocused(true);
    };

    const handleBlur = () => {
      setIsFocused(false);
      // Blur'da formatı düzelt
      if (displayValue && displayValue !== "") {
        const num = parseNumber(displayValue);
        if (num !== "" && num !== 0) {
          setDisplayValue(formatNumber(num));
        } else {
          setDisplayValue("");
        }
      }
    };

    return (
      <input
        type="text"
        inputMode="decimal"
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 text-right tabular-nums",
          className
        )}
        ref={ref}
        value={displayValue}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        {...props}
      />
    );
  }
);

CurrencyInput.displayName = "CurrencyInput";

export { CurrencyInput, formatNumber, parseNumber };
